// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KCfc","content":"styles_content__2cDTf"};